import { render, staticRenderFns } from "./preStartupReview.vue?vue&type=template&id=48cac131"
import script from "./preStartupReview.vue?vue&type=script&lang=js"
export * from "./preStartupReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48cac131')) {
      api.createRecord('48cac131', component.options)
    } else {
      api.reload('48cac131', component.options)
    }
    module.hot.accept("./preStartupReview.vue?vue&type=template&id=48cac131", function () {
      api.rerender('48cac131', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/psr/preStartupReview.vue"
export default component.exports